export function trackVisit() {
  const { pathname, search, hash } = window.location;

  const newVisit = {
    url: `${pathname}${search}${hash}`, // Combine path, query parameters, and hash
    timestamp: new Date().toISOString()
  };

  sessionStorage.setItem('last-visited', JSON.stringify(newVisit));
}
